export default __webpack_public_path__ + "static/media/dexpad-white.755f975f.svg";